module.exports = __webpack_public_path__ + "assets/img/mr1.063b19ee.png";